import React, { useEffect, useState, useCallback } from "react";
import { ApiService } from "../../../../services/ApiService";
import { useAlert } from "react-alert";
import { SystemConfigNavbar } from "../reusedcomponent/Navbar";
import CreateJobTitleModal from "./modal/create_jobtitle";
import CreateJobtitle from "./modal/create_jobtitle";
import EditJobTitleModal from "./modal/edit_jobtile";
import useModal from "../../../../utils/useModal";
import Modal from "react-modal";
import { ConfirmTemplate } from "../../../../components/confirm";
import { PageBody } from "../../../../components/loader";
import { useLoadingMessage } from "../../../../components/useLoadingMessage";
import { systemConfigThunk } from "../../../../store/actions/systemconfiguration/systemconfig.thunk";
import { useDispatch, useSelector } from "react-redux";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "50%",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    // border: "2px solid green",
  },
};

Modal.setAppElement("#root");

export const SystemConfigJobtitle = () => {
  const { isLoading, message, updateLoader } = useLoadingMessage();
  const alert = useAlert();
  const [modalOpen, Setmodalopen] = useState(false);
  // const [jobtitless, setJobtitle] = useState([]);
  const [EditValue, setEditValue] = useState([]);
  const { modalIsOpen, openModal, closeModal } = useModal();
  const [loader, setLoader] = useState(false);

  const openEdit = () => {
    Setmodalopen(true);
  };
  const closeEditModal = () => {
    Setmodalopen(false);
  };

  const { jobtitles, offices } = useSelector((state) => state.systemConfig);
  const dispatch = useDispatch();

  const getJobtitles = useCallback(async () => {
    updateLoader(true, "Loading job titles");
    setLoader(true);
    await dispatch(systemConfigThunk.getJobTitles());
    await dispatch(systemConfigThunk.getOffices());
    setLoader(false);
    updateLoader(false);
  }, [dispatch]);

  useEffect(() => {
    getJobtitles();
  }, []);

  return (
    <PageBody isLoading={isLoading} message={message}>
      <React.Fragment>
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          style={customStyles}
          contentLabel="assign cases modal"
        >
          <CreateJobtitle
            offices={offices}
            getJobtitle={getJobtitles}
            alert={alert}
            closeModal={closeModal}
          />
        </Modal>

        <Modal
          isOpen={modalOpen}
          onRequestClose={closeEditModal}
          style={customStyles}
          contentLabel="assign cases modal"
        >
          <EditJobTitleModal
            closeModal={closeEditModal}
            alert={alert}
            offices={offices}
            getJobtitle={getJobtitles}
            value={EditValue}
          />
        </Modal>

        <SystemConfigNavbar />
        <div class="row container">
          <div class="col-sm-12 col-md-12 col-xs-12">
            <div class="table-wrapper table-responsive">
              <div class="table-title">
                <div class="row">
                  <div class="col-sm-6">
                    <h2>
                      <b>JOB TITLE </b>{" "}
                    </h2>
                  </div>
                  <div class="col-sm-6">
                    <button
                      onClick={openModal}
                      class="btn nt-button-color-action trigger-btn"
                      data-toggle="modal"
                    >
                      <i class="material-icons">&#xE147;</i>{" "}
                      <span> CREATE JOB TITLE</span>
                    </button>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-12 col-xs-12">
                  <div class="registration-form">
                    <table class="table table-bordered asset-table job-title dtMaterialDesignExample">
                      <thead>
                        <tr>
                          <th class="th-sm">NO</th>
                          <th class="th-sm">NAME</th>
                          <th class="th-sm">OFFICE</th>

                          <th class="th-sm">STATUS</th>
                          <th class="th-sm">ACTION</th>
                        </tr>
                      </thead>
                      <tbody id="job_title">
                        {jobtitles.map((jobtitle, i) => (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td>{jobtitle.name.toUpperCase()}</td>
                            <td>{jobtitle.office_id.name.toUpperCase()}</td>
                            <td>
                              {jobtitle.is_active === 1 ? "Active" : null}
                              {jobtitle.is_active === 0 ? "Inactive" : null}
                            </td>
                            <td>
                              <div class="dropdown">
                                <a
                                  href="javascript:void(0)"
                                  class="dropdown-toggle card-drop arrow-none"
                                  data-toggle="dropdown"
                                  aria-expanded="false"
                                >
                                  <h3 class="m-0 text-muted">
                                    <i class="fa fa-ellipsis-v"></i>
                                  </h3>
                                </a>
                                <div
                                  id="dropdown_wrapper"
                                  class="dropdown-menu dropdown-menu-right dropdown_wrapper"
                                  aria-labelledby="btnGroupDrop1"
                                >
                                  {jobtitle.is_active === 1 ? (
                                    <a
                                      class="dropdown-item"
                                      onClick={() => {
                                        const request = () => {
                                          ApiService.post(
                                            `job-titles/deactivate-job-title/${jobtitle.id}`
                                          ).then((res) => {
                                            if (res.data.type === false) {
                                              alert.error(res.data.msg);
                                            } else if (res.data.type === true) {
                                              alert.success(res.data.msg);
                                              getJobtitles();
                                            }
                                          });
                                        };
                                        ConfirmTemplate(
                                          {
                                            title: "Deactivate Job title",
                                            message:
                                              "Are You Sure You Want To Deactivate Job Tile?",
                                          },
                                          request
                                        );
                                      }}
                                    >
                                      Deactivate
                                    </a>
                                  ) : null}

                                  {jobtitle.is_active === 0 ? (
                                    <a
                                      class="dropdown-item"
                                      onClick={() => {
                                        const request = () => {
                                          ApiService.post(
                                            `job-titles/activate-job-title/${jobtitle.id}`
                                          ).then((res) => {
                                            if (res.data.type === false) {
                                              alert.error(res.data.msg);
                                            } else if (res.data.type === true) {
                                              alert.success(res.data.msg);
                                              getJobtitles();
                                            }
                                          });
                                        };
                                        ConfirmTemplate(
                                          {
                                            title: "Activate Job Title",
                                            message:
                                              "Are You Sure You Want To Activate Job Tile?",
                                          },
                                          request
                                        );
                                      }}
                                    >
                                      Activate
                                    </a>
                                  ) : null}

                                  <a
                                    onClick={() => {
                                      const value = {
                                        id: jobtitle.id,
                                        office_id: jobtitle.office_id.id,
                                        jobtitle: jobtitle.name,
                                      };
                                      setEditValue(value);
                                      openEdit();
                                    }}
                                    class="edit dropdown-item"
                                  >
                                    <span>Edit</span>
                                  </a>
                                </div>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    </PageBody>
  );
};



// WEBPACK FOOTER //
// ./src/container/dashboard/systemconfiguration/jobtitle/index.js